module.exports = __webpack_public_path__ + "media/new/outline-32-9da9ece2.png";